import { useState } from 'react';

import { Button, Flex } from '@revenuemarket/cds';
import { Colors, typographyStyle } from '@revenuemarket/design';
import { KeyboardArrowDown } from '@revenuemarket/ui';
import { Typography } from 'antd';

import { css } from '~libs/emotion';

import Cell from './Cell';
import { TreeData, TreeNodeId } from './utils';

const TableCell = <T extends Record<string, unknown>>({
  node,
  onClick,
  onFoldToggle,
  isFocused,
  isActivated,
  foldable,
  cellRenderer,
}: {
  node: TreeData<T>;
  onClick: (nodeId: TreeNodeId) => void;
  onFoldToggle?: (nodeId: TreeNodeId) => void;
  isFocused: boolean;
  isActivated?: boolean;
  foldable?: boolean;
  cellRenderer?: (node: TreeData<T>) => React.ReactNode;
}) => {
  const [isFolded, setIsFolded] = useState(true);

  return (
    <Flex
      data-id={node.key}
      style={{
        // backgroundColor: isFocused ? Colors.blue100 : Colors.white,

        boxShadow: `inset 0 0 0 1px ${Colors.grayOpacity07}`,
        outline:
          isActivated || isFocused ? `${isActivated ? 1.5 : 1}px solid ${Colors.blue500}` : `none`,
      }}
      tabIndex={0} // 접근성 추가
      className={css`
        height: auto;
        min-height: 30px;
        // 아래와 오른쪽만 box-shadow로 border
        &:focus-visible {
          outline: none;
        }
      `}
      align="flex-start"
      onClick={() => {
        onClick(node.key.toString());
      }}
      key={node.key}
    >
      <Cell
        isActionalble={node.value?.isActionable}
        style={{
          width: 160,
          height: 30,
          display: 'flex',
          alignItems: 'center',
        }}
      >
        {foldable && node.children.length ? (
          <Button
            style={{
              padding: 0,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              height: 24,
              width: 24,
              borderRadius: 7,
              margin: 3,
            }}
            icon={
              <KeyboardArrowDown
                style={{
                  transform: isFolded ? 'rotate(270deg)' : 'rotate(0deg)',
                }}
                fill={Colors.gray900}
                className="horizontal-tree-table_fold-icon"
                onClick={(e) => {
                  e.stopPropagation();
                  onFoldToggle && onFoldToggle(node.key);
                  setIsFolded(!isFolded);
                }}
              />
            }
            buttonType="transparent"
          />
        ) : null}
        <Flex
          style={{
            cursor: 'pointer',
            height: '100%',
          }}
          align="center"
        >
          {cellRenderer ? (
            cellRenderer(node)
          ) : (
            <Typography.Text
              ellipsis
              style={{ color: Colors.gray800, ...typographyStyle['13_400'], width: 112 }}
            >
              {node?.value?.label || node?.value?.name}
            </Typography.Text>
          )}
        </Flex>
      </Cell>
    </Flex>
  );
};

export default TableCell;
